import { createSelector } from 'reselect';

const selectEmailCampaigns = (state: any) => state.emailCampaigns;


export const selectEmailCampaignsCurrentItem = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.current);

export const selectEmailCampaignsListItems = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectEmailCampaignsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEmailCampaignsCreatedItem = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.create);
export const selectEmailCampaignsQueryItems = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.query);
export const selectEmailCampaignsUpdatedItem = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.update);

export const selectEmailCampaignsReadItem = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.read);

export const selectEmailCampaignsDeletedItem = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.delete);

export const selectEmailCampaignsSearchedItems = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.search);

export const selectEmailCampaignsItemsCount = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.count);

export const selectEmailCampaignsItemsFilter = createSelector([selectEmailCampaigns], (emailCampaigns) => emailCampaigns.filter);